import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import type { ShoppingList } from '../../types/ShoppingList';

interface ListSelectorProps {
  lists: ShoppingList[];
  selectedListId: string | null;
  onListSelect: (listId: string) => void;
}

export const ListSelector: React.FC<ListSelectorProps> = ({
  lists,
  selectedListId,
  onListSelect
}) => {
  const selectedList = lists.find(list => list.id === selectedListId);

  return (
    <div className="relative">
      <select
        value={selectedListId || ''}
        onChange={(e) => onListSelect(e.target.value)}
        className="w-full appearance-none bg-white border-2 border-orange-100 rounded-lg py-2 px-4 pr-10 focus:border-orange-500 focus:ring-2 focus:ring-orange-200"
      >
        <option value="" disabled>
          Selecciona una lista
        </option>
        {lists.map(list => (
          <option key={list.id} value={list.id}>
            {list.name} ({list.products.length} productos)
          </option>
        ))}
      </select>
      <ChevronDown 
        size={20} 
        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-orange-500 pointer-events-none" 
      />
    </div>
  );
};